import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { FarbeApi } from './FahrzeugdatenFarbeApi';
import { KennzeichenApi } from './FahrzeugdatenKennzeichenApi';
import { FahrzeugscheinApi } from './FahrzeugdatenFahrzeugscheinApi';
import { AnhaengerArtApi } from './FahrzeugdatenAnhaengerArtApi';
import { AchsenArtApi } from './FahrzeugdatenAchsenArtApi';
import { SteckerApi } from './FahrzeugdatenSteckerApi';
import { GarageTypeApi } from './FahrzeugdatenGarageTypeApi';
import { SchadstoffklasseApi } from './FahrzeugdatenSchadstoffklasseApi';
import { SpritApi } from './FahrzeugdatenSpritApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.WebApi.Fahrzeuge.MeinFahrzeugDetail
 * Eigene Fahrzeug-Informationen
 * Endpoints: /api/Garage/{id}, /api/Garage, /api/Garage/SpeicherFahrzeugscheinBild
 */
export class MeinFahrzeugDetailApi extends BaseApiModel {
	constructor(initialProperties?: Partial<MeinFahrzeugDetailApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected referenceId: string;
	/**
	 * Description: Referenz-ID
	 * APIL Type: string
	 */
	get ReferenceId(): string {
		return this.referenceId;
	}

	/**
	 * Description: Referenz-ID
	 * APIL Type: string
	 */
	set ReferenceId(value: string) {
		this.referenceId = value;
	}

	protected zustimmung: boolean;
	/**
	 * Description: Zustimmung zur Datenspeicherung
	 * APIL Type: boolean
	 */
	get Zustimmung(): boolean {
		return this.zustimmung;
	}

	/**
	 * Description: Zustimmung zur Datenspeicherung
	 * APIL Type: boolean
	 */
	set Zustimmung(value: boolean) {
		this.zustimmung = value;
	}

	protected fahrzeugFarbe: FarbeApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.Farbe
	 */
	get FahrzeugFarbe(): FarbeApi {
		return this.fahrzeugFarbe;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.Farbe
	 */
	set FahrzeugFarbe(value: FarbeApi) {
		this.fahrzeugFarbe = value;
	}

	protected zulassung: KennzeichenApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.Kennzeichen
	 */
	get Zulassung(): KennzeichenApi {
		return this.zulassung;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.Kennzeichen
	 */
	set Zulassung(value: KennzeichenApi) {
		this.zulassung = value;
	}

	protected fahrzeugschein: FahrzeugscheinApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.Fahrzeugschein
	 */
	get Fahrzeugschein(): FahrzeugscheinApi {
		return this.fahrzeugschein;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.Fahrzeugschein
	 */
	set Fahrzeugschein(value: FahrzeugscheinApi) {
		this.fahrzeugschein = value;
	}

	protected istNichtDeutschesKennzeichen: boolean;
	/**
	 * Description: Flag dafür, ob es sich beim übermittelten Zulassung,
um ein deutsches Kennzeichen handelt oder nicht
	 * APIL Type: boolean
	 */
	get IstNichtDeutschesKennzeichen(): boolean {
		return this.istNichtDeutschesKennzeichen;
	}

	/**
	 * Description: Flag dafür, ob es sich beim übermittelten Zulassung,
um ein deutsches Kennzeichen handelt oder nicht
	 * APIL Type: boolean
	 */
	set IstNichtDeutschesKennzeichen(value: boolean) {
		this.istNichtDeutschesKennzeichen = value;
	}

	protected fileId: string;
	/**
	 * Description: Id einer hochgeladenen Datei (sollte ein Bild sein)
	 * APIL Type: uuid
	 */
	get FileId(): string {
		return this.fileId;
	}

	/**
	 * Description: Id einer hochgeladenen Datei (sollte ein Bild sein)
	 * APIL Type: uuid
	 */
	set FileId(value: string) {
		this.fileId = value;
	}

	protected fahrzeugBezeichnung: string;
	/**
	 * Description: Bezeichnung des Fahrzeugs (wird nur in der Response erwartet, wenn die FahrzeugId vorliegt)
	 * APIL Type: string
	 */
	get FahrzeugBezeichnung(): string {
		return this.fahrzeugBezeichnung;
	}

	/**
	 * Description: Bezeichnung des Fahrzeugs (wird nur in der Response erwartet, wenn die FahrzeugId vorliegt)
	 * APIL Type: string
	 */
	set FahrzeugBezeichnung(value: string) {
		this.fahrzeugBezeichnung = value;
	}

	protected anhaengerTyp: AnhaengerArtApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.AnhaengerArt
	 */
	get AnhaengerTyp(): AnhaengerArtApi {
		return this.anhaengerTyp;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.AnhaengerArt
	 */
	set AnhaengerTyp(value: AnhaengerArtApi) {
		this.anhaengerTyp = value;
	}

	protected erstzulassung: string;
	/**
	 * Description: Datum der Erstzulassung
	 * APIL Type: date-time
	 */
	get Erstzulassung(): string {
		return this.erstzulassung;
	}

	/**
	 * Description: Datum der Erstzulassung
	 * APIL Type: date-time
	 */
	set Erstzulassung(value: string) {
		this.erstzulassung = value;
	}

	protected achsenzahl: AchsenArtApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.AchsenArt
	 */
	get Achsenzahl(): AchsenArtApi {
		return this.achsenzahl;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.AchsenArt
	 */
	set Achsenzahl(value: AchsenArtApi) {
		this.achsenzahl = value;
	}

	protected laenge: number;
	/**
	 * Description: Länge in mm
	 * APIL Type: int32
	 */
	get Laenge(): number {
		return this.laenge;
	}

	/**
	 * Description: Länge in mm
	 * APIL Type: int32
	 */
	set Laenge(value: number) {
		this.laenge = value;
	}

	protected breite: number;
	/**
	 * Description: Breite in mm
	 * APIL Type: int32
	 */
	get Breite(): number {
		return this.breite;
	}

	/**
	 * Description: Breite in mm
	 * APIL Type: int32
	 */
	set Breite(value: number) {
		this.breite = value;
	}

	protected hoehe: number;
	/**
	 * Description: Höhne in mm
	 * APIL Type: int32
	 */
	get Hoehe(): number {
		return this.hoehe;
	}

	/**
	 * Description: Höhne in mm
	 * APIL Type: int32
	 */
	set Hoehe(value: number) {
		this.hoehe = value;
	}

	protected steckertyp: SteckerApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.Stecker
	 */
	get Steckertyp(): SteckerApi {
		return this.steckertyp;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.Stecker
	 */
	set Steckertyp(value: SteckerApi) {
		this.steckertyp = value;
	}

	protected gewichtMax: number;
	/**
	 * Description: Zulässiges Gesamtgewicht
	 * APIL Type: double
	 */
	get GewichtMax(): number {
		return this.gewichtMax;
	}

	/**
	 * Description: Zulässiges Gesamtgewicht
	 * APIL Type: double
	 */
	set GewichtMax(value: number) {
		this.gewichtMax = value;
	}

	protected id: string;
	/**
	 * Description: ID des Fahrzeugs (KfzId/FahrzeugId, Hierarchiestufe 5)
	 * APIL Type: string
	 */
	get Id(): string {
		return this.id;
	}

	/**
	 * Description: ID des Fahrzeugs (KfzId/FahrzeugId, Hierarchiestufe 5)
	 * APIL Type: string
	 */
	set Id(value: string) {
		this.id = value;
	}

	protected dataSourceRef: string;
	/**
	 * Description: Referenz für Hermes (TETKey, neu und alt)
	 * APIL Type: string
	 */
	get DataSourceRef(): string {
		return this.dataSourceRef;
	}

	/**
	 * Description: Referenz für Hermes (TETKey, neu und alt)
	 * APIL Type: string
	 */
	set DataSourceRef(value: string) {
		this.dataSourceRef = value;
	}

	protected name: string;
	/**
	 * Description: Name des Fahrzeugs
Bei Autos der Eintrag unter Fahrzeug
Bei Motorrad Marke + Modell + Baureihe
Bei Anhängern der selbstgeewählte
	 * APIL Type: string
	 */
	get Name(): string {
		return this.name;
	}

	/**
	 * Description: Name des Fahrzeugs
Bei Autos der Eintrag unter Fahrzeug
Bei Motorrad Marke + Modell + Baureihe
Bei Anhängern der selbstgeewählte
	 * APIL Type: string
	 */
	set Name(value: string) {
		this.name = value;
	}

	protected typ: GarageTypeApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.GarageType
	 */
	get Typ(): GarageTypeApi {
		return this.typ;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.GarageType
	 */
	set Typ(value: GarageTypeApi) {
		this.typ = value;
	}

	protected marke: string;
	/**
	 * Description: Marke (sollte MarkeId sein, kann aber auch Bezeichner sein)
Hierarchiestufe 1
	 * APIL Type: string
	 */
	get Marke(): string {
		return this.marke;
	}

	/**
	 * Description: Marke (sollte MarkeId sein, kann aber auch Bezeichner sein)
Hierarchiestufe 1
	 * APIL Type: string
	 */
	set Marke(value: string) {
		this.marke = value;
	}

	protected markeId: number;
	/**
	 * Description: Alternative Möglichkeit für die MarkeId, falls Marke der Bezeichner ist
Hierarchiestufe 1
	 * APIL Type: int32
	 */
	get MarkeId(): number {
		return this.markeId;
	}

	/**
	 * Description: Alternative Möglichkeit für die MarkeId, falls Marke der Bezeichner ist
Hierarchiestufe 1
	 * APIL Type: int32
	 */
	set MarkeId(value: number) {
		this.markeId = value;
	}

	protected baureihe: string;
	/**
	 * Description: Baureihe (sollte BaureiheId sein, kann aber auch Bezeichner sein)
Hierarchiestufe 2
	 * APIL Type: string
	 */
	get Baureihe(): string {
		return this.baureihe;
	}

	/**
	 * Description: Baureihe (sollte BaureiheId sein, kann aber auch Bezeichner sein)
Hierarchiestufe 2
	 * APIL Type: string
	 */
	set Baureihe(value: string) {
		this.baureihe = value;
	}

	protected baureiheId: number;
	/**
	 * Description: Alternative Möglichkeit für die BaureiheId, falls Baureihe der Bezeichner ist
Hierarchiestufe 2
	 * APIL Type: int32
	 */
	get BaureiheId(): number {
		return this.baureiheId;
	}

	/**
	 * Description: Alternative Möglichkeit für die BaureiheId, falls Baureihe der Bezeichner ist
Hierarchiestufe 2
	 * APIL Type: int32
	 */
	set BaureiheId(value: number) {
		this.baureiheId = value;
	}

	protected baureiheGeneration: string;
	/**
	 * Description: BaureiheGeneration (sollte BaureiheGenerationId sein, kann aber auch Bezeichner sein)
Hierarchiestufe 3
	 * APIL Type: string
	 */
	get BaureiheGeneration(): string {
		return this.baureiheGeneration;
	}

	/**
	 * Description: BaureiheGeneration (sollte BaureiheGenerationId sein, kann aber auch Bezeichner sein)
Hierarchiestufe 3
	 * APIL Type: string
	 */
	set BaureiheGeneration(value: string) {
		this.baureiheGeneration = value;
	}

	protected baureiheGenerationId: number;
	/**
	 * Description: Alternative Möglichkeit für die BaureiheGenerationId, falls BaureiheGeneration der Bezeichner ist
Hierarchiestufe 3
	 * APIL Type: int32
	 */
	get BaureiheGenerationId(): number {
		return this.baureiheGenerationId;
	}

	/**
	 * Description: Alternative Möglichkeit für die BaureiheGenerationId, falls BaureiheGeneration der Bezeichner ist
Hierarchiestufe 3
	 * APIL Type: int32
	 */
	set BaureiheGenerationId(value: number) {
		this.baureiheGenerationId = value;
	}

	protected modell: string;
	/**
	 * Description: Modell (sollte ModellVarianteId sein, kann aber auch Bezeichner sein)
Hierarchiestufe 4
	 * APIL Type: string
	 */
	get Modell(): string {
		return this.modell;
	}

	/**
	 * Description: Modell (sollte ModellVarianteId sein, kann aber auch Bezeichner sein)
Hierarchiestufe 4
	 * APIL Type: string
	 */
	set Modell(value: string) {
		this.modell = value;
	}

	protected modellVarianteId: number;
	/**
	 * Description: Alternative Möglichkeit für die ModellVarianteId {, falls Modell der Bezeichner ist
Hierarchiestufe 4
	 * APIL Type: int32
	 */
	get ModellVarianteId(): number {
		return this.modellVarianteId;
	}

	/**
	 * Description: Alternative Möglichkeit für die ModellVarianteId {, falls Modell der Bezeichner ist
Hierarchiestufe 4
	 * APIL Type: int32
	 */
	set ModellVarianteId(value: number) {
		this.modellVarianteId = value;
	}

	protected karosserie: string;
	/**
	 * Description: Karosserievariante (Aufbau)
	 * APIL Type: string
	 */
	get Karosserie(): string {
		return this.karosserie;
	}

	/**
	 * Description: Karosserievariante (Aufbau)
	 * APIL Type: string
	 */
	set Karosserie(value: string) {
		this.karosserie = value;
	}

	protected verbrauch: number;
	/**
	 * Description: Durchschnittlicher Verbrauch pro 100km
	 * APIL Type: double
	 */
	get Verbrauch(): number {
		return this.verbrauch;
	}

	/**
	 * Description: Durchschnittlicher Verbrauch pro 100km
	 * APIL Type: double
	 */
	set Verbrauch(value: number) {
		this.verbrauch = value;
	}

	protected euroNorm: SchadstoffklasseApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.Schadstoffklasse
	 */
	get EuroNorm(): SchadstoffklasseApi {
		return this.euroNorm;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.Schadstoffklasse
	 */
	set EuroNorm(value: SchadstoffklasseApi) {
		this.euroNorm = value;
	}

	protected kraftstoff: SpritApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.Sprit
	 */
	get Kraftstoff(): SpritApi {
		return this.kraftstoff;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Fahrzeugdaten.Sprit
	 */
	set Kraftstoff(value: SpritApi) {
		this.kraftstoff = value;
	}

	protected zeitstempel: string;
	/**
	 * Description: Zeitstempel für die Datenänderung
	 * APIL Type: date-time
	 */
	get Zeitstempel(): string {
		return this.zeitstempel;
	}

	/**
	 * Description: Zeitstempel für die Datenänderung
	 * APIL Type: date-time
	 */
	set Zeitstempel(value: string) {
		this.zeitstempel = value;
	}

	protected href: string;
	/**
	 * Description: Referenz auf ein Detail
	 * APIL Type: uri
	 */
	get Href(): string {
		return this.href;
	}

	/**
	 * Description: Referenz auf ein Detail
	 * APIL Type: uri
	 */
	set Href(value: string) {
		this.href = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): MeinFahrzeugDetailApi {
		return AppUtils.Helper.createFromMap(dataObject, MeinFahrzeugDetailApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'zulassung':
					return KennzeichenApi.createFromObject(value);
				case 'fahrzeugschein':
					return FahrzeugscheinApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.ReferenceId = this.referenceId;
		result.Zustimmung = this.zustimmung;
		result.FahrzeugFarbe = this.fahrzeugFarbe;
		if (this.zulassung) {
			result.Zulassung = this.zulassung.toRequestObject();
		}
		if (this.fahrzeugschein) {
			result.Fahrzeugschein = this.fahrzeugschein.toRequestObject();
		}
		result.IstNichtDeutschesKennzeichen = this.istNichtDeutschesKennzeichen;
		result.FileId = this.fileId;
		result.FahrzeugBezeichnung = this.fahrzeugBezeichnung;
		result.AnhaengerTyp = this.anhaengerTyp;
		result.Erstzulassung = this.erstzulassung;
		result.Achsenzahl = this.achsenzahl;
		result.Laenge = this.laenge;
		result.Breite = this.breite;
		result.Hoehe = this.hoehe;
		result.Steckertyp = this.steckertyp;
		result.GewichtMax = this.gewichtMax;
		result.Id = this.id;
		result.DataSourceRef = this.dataSourceRef;
		result.Name = this.name;
		result.Typ = this.typ;
		result.Marke = this.marke;
		result.MarkeId = this.markeId;
		result.Baureihe = this.baureihe;
		result.BaureiheId = this.baureiheId;
		result.BaureiheGeneration = this.baureiheGeneration;
		result.BaureiheGenerationId = this.baureiheGenerationId;
		result.Modell = this.modell;
		result.ModellVarianteId = this.modellVarianteId;
		result.Karosserie = this.karosserie;
		result.Verbrauch = this.verbrauch;
		result.EuroNorm = this.euroNorm;
		result.Kraftstoff = this.kraftstoff;
		result.Zeitstempel = this.zeitstempel;
		result.Href = this.href;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}